import React, {useContext, useEffect} from 'react';
import AuthContext from '../../context/autenticacion/authContext';
import { AiOutlineLogout } from "react-icons/ai";
//import criticaContext from '../../context/criticas/criticaContext';

const Barra = () => {

    // Extraer la información de autenticación
    const authContext = useContext(AuthContext);
    const { usuario, usuarioAutenticado, cerrarSesion  } = authContext;

     // obtener la función del context de critica
     //const criticasContext = useContext(criticaContext);

    useEffect(() => {
        usuarioAutenticado();
        // eslint-disable-next-line
    }, []);

    return ( 
        <header className="app-header">
            {usuario ? <p className="nombre-usuario">Hola {""}
            <span className="colorYellow">{ usuario.nombre.slice(0,1).toUpperCase()+ usuario.nombre.slice(1,usuario.nombre.length)} </span> </p> 
            : null}
            
            <nav className="nav-principal">
            <div className="justifyTextIcon">
                <button 
                    className="btn btn-blank cerrar-sesion"
                    onClick={() => cerrarSesion() }
                >Cerrar Sesión </button>
                <AiOutlineLogout size="25" color="ffca28"/>
            </div>
            </nav>
        </header>
     );
}
 
export default Barra;